module.exports = __webpack_public_path__ + "static/img/14.cac11d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empresas/14.png
// module id = seCh
// module chunks = 0